import ProgramScenario, { PlainProgramScenario } from './Scenario';
import Worksheet, { PlainWorksheet } from './Worksheet';

export interface SummaryCalculator {
  circulationUSF: number;

  circulationPercentage: number;

  additionalUSFForPlanningFactor: number;

  subtotalMultiplierForCirculation: number;

  subtotalProgramWithCirculationUSF: number;

  subtotalProgramUSF: number;

  planningFactorPercentage: number;

  rsfLoadFactorPercentage: number;

  rentableLoadFactor: number;

  totalProgramRSF: number;

  totalProgramUSF: number;

  deltaProgramUSF: number;

  deltaProgramRSF: number;
}

export default class ProgramSummaryCalculator implements SummaryCalculator {
  private scenario: PlainProgramScenario;

  private worksheet: Worksheet | PlainWorksheet;

  circulationUSF: number;

  circulationPercentage: number;

  additionalUSFForPlanningFactor: number;

  subtotalProgramWithCirculationUSF: number;

  subtotalProgramUSF: number;

  totalProgramUSF: number;

  deltaProgramUSF: number;

  deltaProgramRSF: number;

  planningFactorPercentage: number;

  rsfLoadFactorPercentage: number;

  rentableLoadFactor: number;

  totalProgramRSF: number;

  subtotalMultiplierForCirculation = 0;

  constructor(
    scenario: PlainProgramScenario | ProgramScenario,
    worksheet: PlainWorksheet | Worksheet
  ) {
    this.scenario = scenario;
    this.worksheet = worksheet;
    if (!scenario || !worksheet) return;
    this.subtotalMultiplierForCirculation =
      scenario.subtotalMultiplierForCirculation;
    this.planningFactorPercentage = scenario.planningFactorPercentage;
    this.rsfLoadFactorPercentage = scenario.rsfLoadFactorPercentage;
    this.calculate();
  }

  calculate = () => {
    this.circulationUSF =
      this.worksheet.subtotalProgramUSF *
      this.scenario.subtotalMultiplierForCirculation;
    this.subtotalProgramUSF = this.worksheet.subtotalProgramUSF;
    this.subtotalProgramWithCirculationUSF =
      this.circulationUSF + this.worksheet.subtotalProgramUSF;

    this.circulationPercentage = this.calculateCirculationPercentage();

    this.additionalUSFForPlanningFactor = this.calculateAdditionalUSFForPlanningFactor();

    this.totalProgramUSF =
      this.additionalUSFForPlanningFactor +
      this.subtotalProgramWithCirculationUSF;

    this.rentableLoadFactor =
      this.totalProgramUSF * (this.rsfLoadFactorPercentage / 100);

    this.totalProgramRSF = this.totalProgramUSF + this.rentableLoadFactor;

    this.deltaProgramUSF =
      (this.scenario.totalAvailableUSF || 0) - this.totalProgramUSF;

    this.deltaProgramRSF =
      (this.scenario.totalAvailableRSF || 0) - this.totalProgramRSF;
  };

  calculateCirculationPercentage = () => {
    const { subtotalMultiplierForCirculation } = this.scenario;
    return (
      (subtotalMultiplierForCirculation * 100) /
      (1 + subtotalMultiplierForCirculation)
    );
  };

  calculateAdditionalUSFForPlanningFactor = () => {
    const { planningFactorPercentage } = this.scenario;

    return (
      (planningFactorPercentage / 100) * this.subtotalProgramWithCirculationUSF
    );
  };

  toPlainObject = () => ({
    circulationUSF: this.circulationUSF,
    circulationPercentage: this.circulationPercentage,
    additionalUSFForPlanningFactor: this.additionalUSFForPlanningFactor,
    subtotalProgramWithCirculationUSF: this.subtotalProgramWithCirculationUSF,
    totalProgramUSF: this.totalProgramUSF,
    deltaProgramUSF: this.deltaProgramUSF,
    planningFactorPercentage: this.planningFactorPercentage,
    rsfLoadFactorPercentage: this.rsfLoadFactorPercentage,
    rentableLoadFactor: this.rentableLoadFactor,
    totalProgramRSF: this.totalProgramRSF,
    deltaProgramRSF: this.deltaProgramRSF,
    subtotalProgramUSF: this.subtotalProgramUSF,
    subtotalMultiplierForCirculation: this.subtotalMultiplierForCirculation,
  });
}
